export default __webpack_public_path__ + "static/bismillah-86a89d4922cb7cb89862c0ff59e2259b.webp";